// import AppError from 'Core/services/errors.service';
import DevicesService from '@/services/devices.service';
import SocketService from '@/services/socket.service';

const UpdatingDeviceMixins = {
  data() {
    return {
      updatingWS: false,
      timeoutUpgrading: 0,
      useManualWifiPassword: false,
      socketConnection: false,
      fwVersionState: 'success', // [success, loading, outdated],
      lastVersion: {},
    };
  },

  computed: {
    /**
     * En caso de existir mensaje de información de la versión en el idioma seleccionado
     * en la app, se muestra el mismo.
     * NOTA: Si no existe texto en mi idioma, sólo se muestra número de versión.
     *
     * @returns {string} - Mensaje en formato HTML
     */
    getVersionMessage() {
      return `${this.$i18n.t('unit.version')} ${this.lastVersion.version}`;
    },
  },

  methods: {
    /**
     * Inicia actualiación y timeout para terminar el fin actualización sino llega el evento
     */
    async startTimeout(timeout) {
      this.updatingWS = true;
      this.fwVersionState = 'loading';
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: this.$i18n.t('new2.addUnit.updatingWebserver'),
      });
      clearTimeout(this.timeoutUpgrading);
      this.showUpdateVersionDevice = false;
      SocketService.initWebserverUpdates(this.device.mac);
      await this.upgradeDeviceVersion();
      //
      // Iniciamos timeout para realizar el proceso de actualización.
      // Si se alcanza el final de la cuenta cancelamos y mostramos error
      //
      this.timeoutUpgrading = setTimeout(async () => {
        console.log('Finish timeout. No se ha obtenido respuesta del websocket');
        // Lanza un error si aún no se ha obtenido respuesta desde el socket tras un tiempo
        if (this.updatingWS) {
          this.launchError();
          // throw new AppError('timeout', 'Timeout upgrading webserver');
        }

        // this.$toast.fail({
        //   mask: true,
        //   message: this.$i18n.t('messages.defaultError.message'),
        // })
      }, timeout);
    },

    /**
     * En caso de error en el proces de actualización, reiniciamos las variables que controlan
     * el estado y mostramos un modal de error
     */
    launchError() {
      this.updatingWS = false;
      this.fwVersionState = 'outdated';
      this.$toast.fail({
        mask: true,
        message: this.$i18n.t('errors.general.message'),
      });
    },

    /**
     * Captura evento de terminado para limpiar el timeout y listener websocket. Muestra mensaje de conectado correctamente
     */
    async upgradingWebserverFinish(e) {
      console.log('upgradingWebserver => Finish Event: ', e);
      this.device.wsver = this.lastVersion.version;
      await this.initVersion();
      this.updatingWS = false;
      this.clearTimeout();
      this.fwVersionState = 'success';
      this.$toast.success({
        mask: true,
        message: this.$i18n.t('home.updatedSuccess'),
      });
    },

    /**
     * Limpia el timeout y listener websocket. Oculta 'Conectando' y 'Actualizando'
     */
    clearTimeout() {
      console.log('Limpio timeout y listeners OTA del websockets');
      this.updatingWS = false;
      clearTimeout(this.timeoutUpgrading);
      SocketService.finishOTA();
    },

    /**
     * Realiza la petición para obtener el estado de las actualizaciones disponibles
     *
     * @returns {Object} - Información sobre las últimas versiones disponibles
     */
    getVersions() {
      return new Promise(async (resolve, reject) => {
        try {
          console.log('Iniciando petición de última versión de esta mac: ', this.device.mac);
          // Realizo la petición
          const resp = await DevicesService.getDeviceVersion(this.device.mac);
          console.log('getDeviceVersion: ', resp);
          resolve(resp);
        } catch (err) {
          this.hasOTA = false;
          reject(err);
        }
      });
    },

    /**
     *  Lanza el modal de información y confirmación de la nueva versión
     */
    checkVersion() {
      if (this.fwVersionState !== 'outdated' || this.appName !== 'dknna' || !this.hasOTA) return;

      if (!this.device.isDeviceConnectedToWifi) {
        this.showRequiredInternet = true;
      } else {
        this.showUpdateVersionDevice = true;
      }
    },

    /**
     * Se encarga de lanzar la petición para actualizar a la última versión.
     * NOTA: La finalización de la actualización nos llegará por evento de socket
     */
    async upgradeDeviceVersion() {
      try {
        await DevicesService.upgradeDeviceVersion(this.device.mac);
      } catch (err) {
        console.log(err);
        this.launchError();
        this.clearTimeout();
      }
    },

    /**
     * Manejador para el evento webserverUpdates. Trata de refrescar el estado del icono
     * de la versión en caso de que el firmaware se haya actualizado
     *
     * @param {CustomEvent}
     */
    updateFwStatus(e) {
      if (
        e.detail &&
        e.detail.firmware !== undefined &&
        e.detail.firmware !== this.lastVersion.version
      ) {
        this.initVersion();
      }
    },

    /**
     * Comprueba si hay actualizaciones disponibles y actualiza el estado del icono
     * de versiones
     */
    async initVersion() {
      this.fwVersionState = 'loading';
      await this.getVersions()
        .then(res => {
          this.lastVersion = res;
          if (this.lastVersion.version !== undefined) {
            console.log(this.lastVersion);
            if (this.device.wsver === this.lastVersion.version) {
              this.fwVersionState = 'success';
            } else {
              this.fwVersionState = 'outdated';
            }
          } else {
            this.fwVersionState = 'success';
          }
        })
        .catch(err => {
          console.log(err);
          if (
            (err.response.data && err.response.data._id === 'deviceNotSupported') ||
            err.response.data._id === 'deviceNotConnected'
          ) {
            this.hasOTA = false;
          }
        });
    },
  },

  async created() {
    await this.initVersion();
  },

  mounted() {
    document.addEventListener('finishOTA', this.upgradingWebserverFinish);
    document.addEventListener('webserverUpdates', this.updateFwStatus);
  },

  destroyed() {
    document.removeEventListener('finishOTA', this.upgradingWebserverFinish);
    document.removeEventListener('webserverUpdates', this.updateFwStatus);
  },
};

export default UpdatingDeviceMixins;
